var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { COMMON_TYPES, GET_DEV_PLAN_TYPES, PURCHASE_DEV_PLAN_TYPES, SEND_EMAIL_VERIFICATION_TYPES, VERIFY_EMAIL_TYPES, } from './types';
import services from '../../services';
var DeveloperPlansService = services.DeveloperPlansService, AuthService = services.AuthService;
export var getDevPlans = function (orgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var devPlans, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: GET_DEV_PLAN_TYPES.REQUEST });
                return [4 /*yield*/, DeveloperPlansService.listDeveloperPlansOrg(orgId)];
            case 1:
                devPlans = (_a.sent()).objects;
                dispatch({ type: GET_DEV_PLAN_TYPES.SUCCESS, devPlans: devPlans });
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                dispatch({ type: GET_DEV_PLAN_TYPES.FAILURE, error: error_1 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var setSelectedDevPlan = function (devPlanId) { return function (dispatch) {
    dispatch({ type: COMMON_TYPES.SELECT_DEV_PLAN, devPlanId: devPlanId });
}; };
export var setSelectedDevPlanTrial = function (trial) { return function (dispatch) {
    dispatch({ type: COMMON_TYPES.SET_DEV_PLAN_TRIAL, trial: trial });
}; };
export var holdModal = function () { return function (dispatch) {
    dispatch({ type: COMMON_TYPES.SHOULD_HOLD });
}; };
export var setCurrentStep = function (step) { return function (dispatch) {
    dispatch({ type: COMMON_TYPES.NAVIGATE_STEPS, step: step });
}; };
export var resetConfigureAccountState = function () { return function (dispatch) {
    dispatch({ type: COMMON_TYPES.RESET_STATE });
}; };
export var setDevPlanInterval = function (interval) {
    return function (dispatch) {
        dispatch({ type: COMMON_TYPES.SET_DEV_PLAN_INTERVAL, interval: interval });
    };
};
export var purchaseDevPlan = function (devPlanId, orgId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var devPlan, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: PURCHASE_DEV_PLAN_TYPES.REQUEST });
                    return [4 /*yield*/, DeveloperPlansService.purchaseDeveloperPlansOrg(orgId, devPlanId, [])];
                case 1:
                    devPlan = (_a.sent()).object;
                    dispatch({ type: PURCHASE_DEV_PLAN_TYPES.SUCCESS, devPlan: devPlan });
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    dispatch({ type: PURCHASE_DEV_PLAN_TYPES.FAILURE, error: error_2 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var createEmailVerificationData = function (key, data) {
    return function (dispatch) {
        dispatch({ type: COMMON_TYPES.SET_EMAIL_VERIFICATION_DATA, key: key, data: data });
    };
};
export var sendEmailVerification = function (email) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: SEND_EMAIL_VERIFICATION_TYPES.REQUEST });
                    return [4 /*yield*/, AuthService.sendUserEmailVerification({ email: email, signup_id: '' })];
                case 1:
                    _a.sent();
                    dispatch({ type: SEND_EMAIL_VERIFICATION_TYPES.SUCCESS });
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    dispatch({ type: SEND_EMAIL_VERIFICATION_TYPES.FAILURE, error: error_3 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var verifyEmail = function (email, code) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: VERIFY_EMAIL_TYPES.REQUEST });
                    return [4 /*yield*/, AuthService.verifyEmail(email, code)];
                case 1:
                    response = (_a.sent()).object;
                    dispatch({ type: VERIFY_EMAIL_TYPES.SUCCESS, response: response });
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    dispatch({ type: VERIFY_EMAIL_TYPES.FAILURE, error: error_4 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
